import React, { Component } from 'react';
import FormItem from '../../components/FormItem/index';
import Wangeditor from '../../components/Wangeditor/index';
import { Form, Input, Button, message, Checkbox, Radio } from 'antd';
import PreviewUploadComponent from '../../components/Upload/previewImg';
import services from '../../services/api';

const { TextArea } = Input;
// const RadioGroup = Radio.Group;
class NewsAdd extends Component {
  constructor() {
    super();
    this.state = {
      detail: {}
    };
    this.actionType = 'add';
    this.type = '';
    this.id = '';
  }

  componentDidMount() {
    if (this.props.actionType) {
      this.actionType = this.props.actionType;
    } else {
      if (this.props.location.pathname.indexOf('edit') !== -1) {
        this.actionType = 'update';
        this.id = this.props.match.params.id;
        this.getDetail();
      }
      this.type = this.props.match.params.type;
    }
  }

  /**获取详情 */
  getDetail = () => {
    services.news.queryOne({ id: this.id }).then(data => {
      console.log(data);
      if (data.code === 0) {
        this.setState({
          detail: data.data
        });
        this.props.form.setFieldsValue({
          title: data.data.title,
          click_num: data.data.click_num,
          des: data.data.des,
          is_top: data.data.is_top,
          orders: data.data.orders,
          cname: data.data.cname,
          content: { html: data.data.content },
          preview_image: { fileUrl: data.data.preview_image }
        });
        if (this.type === 'video') {
          this.props.form.setFieldsValue({
            youku_video: data.data.youku_video
          });
        }
      } else {
        message.error(data.msg);
      }
    });
  };

  /** 获取到列表url  */
  getListUrl = () => {
    const addUrlReg = /.+(?=\/add)/;
    const editUrlReg = /.+(?=\/\d+\/edit)/;
    if (this.props.location.pathname.match(addUrlReg) !== null) {
      return this.props.location.pathname.match(addUrlReg)[0];
    }
    if (this.props.location.pathname.match(editUrlReg) !== null) {
      return this.props.location.pathname.match(editUrlReg)[0];
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      console.log(values);
      const params = {
        ...values,
        type: this.type,
        is_top: values.is_top ? 1 : 0,
        click_num: values.click_num ? parseInt(values.click_num, 10) : 0,
        orders: values.orders ? parseInt(values.orders, 10) : 999,
        preview_image: values.preview_image.fileUrl
      };
      if (this.type !== 'video') {
        params.content = values.content.html;
      }
      if (this.actionType === 'update') {
        params.id = this.id;
      }
      if (!err) {
        services.news[this.actionType](params).then(data => {
          if (data.code === 0) {
            message.success(data.msg);
            this.props.history.push(this.getListUrl());
          } else {
            message.error(data.msg);
          }
        });
      }
    });
  };

  render() {
    const formItems1 = [
      {
        label: {
          label: '名称',
          className: 'tantuer-form-item'
        },
        name: 'title',
        options: {
          initialValue: '',
          rules: [{ required: true, message: '请输入名称' }]
        },
        component: <Input placeholder="名称" className="large" />,
        children: [
          {
            name: 'is_top',
            options: {
              initialValue: ''
            },
            component: <Checkbox>置顶</Checkbox>
          }
        ]
      },

      {
        label: {
          label: '排序',
          className: 'tantuer-form-item'
        },
        name: 'orders',
        options: {
          initialValue: ''
        },
        component: (
          <Input placeholder="数字越小越靠前，默认999" className="default" />
        )
      },
      // {
      //   label: {
      //     label: '是否跳转',
      //     className: 'tantuer-form-item'
      //   },
      //   name: 'is_redirect',
      //   options: {
      //     initialValue: ''
      //   },
      //   component: (
      //     <RadioGroup>
      //       <Radio value={1}>是</Radio>
      //       <Radio value={2}>否</Radio>
      //     </RadioGroup>
      //   ),
      //   children: [
      //     {
      //       name: 'redirect_url',
      //       options: {
      //         initialValue: ''
      //       },
      //       component: <Input placeholder="跳转url" className="default" />
      //     }
      //   ]
      // },
      {
        label: {
          label: '别名',
          className: 'tantuer-form-item'
        },
        name: 'cname',
        options: {
          initialValue: ''
        },
        component: <Input placeholder="别名" className="default" />
      },
      {
        label: {
          label: '点击量',
          className: 'tantuer-form-item'
        },
        name: 'click_num',
        options: {
          initialValue: ''
        },
        component: <Input placeholder="点击量" className="default" />
      },
      {
        label: {
          label: '描述',
          className: 'tantuer-form-item'
        },
        name: 'des',
        options: {
          initialValue: ''
        },
        component: <TextArea placeholder="描述" className="default" />
      }
    ];
    const formItems2 = [
      {
        label: {
          label: '缩略图',
          className: 'tantuer-form-item'
        },
        name: 'preview_image',
        options: {
          initialValue: { fileUrl: '' }
        },
        component: <PreviewUploadComponent />
      }
    ];
    this.type === 'video' &&
      formItems2.push({
        label: {
          label: '优酷视频地址',
          className: 'tantuer-form-item',
          extra: '仅当视频列表填写'
        },
        name: 'youku_video',
        options: {
          initialValue: '',
          rules: [{ required: true, message: '请输入视频地址' }]
        },
        component: <Input placeholder="视频地址" className="large" />
      });
    const formItems3 = [
      {
        label: {
          label: '详情',
          className: 'tantuer-form-item'
        },
        name: 'content',
        options: {
          initialValue: { html: '' },
          rules: [{ required: true, message: '请输入详情' }]
        },
        component: <Wangeditor />
      }
    ];

    return (
      <div>
        <Form onSubmit={this.handleSubmit} className="login-form">
          <div className="tantuer-field-area">
            {formItems1.map(item => {
              return (
                <FormItem key={item.name} form={this.props.form} item={item} />
              );
            })}
          </div>
          <div className="tantuer-field-area">
            {formItems2.map(item => {
              return (
                <FormItem key={item.name} form={this.props.form} item={item} />
              );
            })}
          </div>
          {this.type !== 'video' && (
            <div className="tantuer-field-area">
              {formItems3.map(item => {
                return (
                  <FormItem
                    key={item.name}
                    form={this.props.form}
                    item={item}
                  />
                );
              })}
            </div>
          )}

          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            提交
          </Button>
        </Form>
      </div>
    );
  }
}

export default Form.create()(NewsAdd);
